<template>
  <div class="com-page">
    <div class="com-content">
      <div class="page-block">
        <div class="page-path">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index">
              <span v-if="!item.path" class="blank-path">{{ item.name }}</span>
              <router-link v-else :to="item.path">{{ item.name }}</router-link>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="page-name">{{ pageTitle }}</div>
      </div>
      <div class="button-block">
        <el-button v-if="showBack" class="back" plain @click="pageBack">
          <i class="iconfont iconzu131" />返回
        </el-button>
      </div>
    </div>
    <div v-if="materialNav" class="com-nav">
      <el-menu router :default-active="$route.path" mode="horizontal">
        <el-menu-item index="/material/menu-list">Menu清单</el-menu-item>
        <el-menu-item index="/material/campaign" disabled>活动物料</el-menu-item>
        <el-menu-item index="/material/printing-list">印刷品</el-menu-item>
        <el-menu-item index="/material/non-menu">Non Menu</el-menu-item>
      </el-menu>
    </div>
    <div v-if="orderNav" class="com-nav order-nav">
      <el-menu router :default-active="$route.path" mode="horizontal">
        <el-menu-item index="/order/list/pocm">POCM订单</el-menu-item>
        <el-menu-item index="/order/list/campaign" disabled>活动订单</el-menu-item>
        <el-menu-item index="/order/list/non-menu">Non Menu订单</el-menu-item>
        <!-- <el-menu-item index="/order/list/freezer">冰柜订单</el-menu-item> -->
        <el-menu-item index="" disabled>冰柜订单</el-menu-item>
        <el-menu-item index="/order/list/shop-sign">店招订单</el-menu-item>
        <el-menu-item index="/order/list/logistics">物流费订单</el-menu-item>
      </el-menu>
    </div>
    <div v-if="budgetNav" class="com-nav budget-nav">
      <el-menu router :default-active="$route.path" mode="horizontal">
        <el-menu-item index="/budget/pocm">POCM预算</el-menu-item>
        <el-menu-item index="/budget/tr">TR预算</el-menu-item>
      </el-menu>
    </div>
    <div v-if="stockNav" class="com-nav stock-nav">
      <el-menu router :default-active="$route.path" mode="horizontal">
        <el-menu-item index="/stock/apply" v-if="canApply">物资申请</el-menu-item>
        <el-menu-item index="/stock/approve" v-if="canApprove">申请审核</el-menu-item>
        <el-menu-item index="/stock/money" v-if="canMoney">金额配额</el-menu-item>
        <el-menu-item index="/stock/stock" v-if="canStock">库存</el-menu-item>
        <el-menu-item index="/stock/quota" v-if="canQuota">物资领用</el-menu-item>
        <el-menu-item index="/stock/logitics">运单查询</el-menu-item>
      </el-menu>
    </div>
    <div v-if="gameplanNav"  class="com-nav">
      <el-menu router :default-active="$route.path" mode="horizontal">
        <!-- <el-menu-item index="/gameplan/activity-mangement/all">活动列表</el-menu-item>
        <el-menu-item index="/gameplan/activity-detail/all">活动详情</el-menu-item>
        <el-menu-item index="/gameplan/activity-salePlace/all">活动售点列表</el-menu-item> -->
        <!-- <el-menu-item index="/material/campaign" disabled>活动物料</el-menu-item> -->
      </el-menu>
    </div>

    <!-- 尊享先锋门店管理 -->
    <div v-if="perfectNavList.length" class="com-nav">
      <el-menu router :default-active="$route.path" mode="horizontal">
        <el-menu-item v-for="item in perfectNavList" :key="item.path" :index="item.path">
          {{ item.title }}
        </el-menu-item>
      </el-menu>
    </div>
    <!-- 冰柜管理 -->
    <div v-if="freezer" class="com-nav ">
      <el-menu router :default-active="$route.path" mode="horizontal">
        <el-menu-item style="width:180px" index="/trade/cooler/store">冰柜丢失/报废登记</el-menu-item>
        <el-menu-item  style="width:180px" index="/trade/cooler/all">查看冰柜信息</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'contentHeader',
  props: {
    gameplanNav: {
      type: Boolean,
      default: false
    },
    materialNav: {
      type: Boolean,
      default: false
    },
    orderNav: {
      type: Boolean,
      default: false
    },
    budgetNav: {
      type: Boolean,
      default: false
    },
    stockNav: {
      type: Boolean,
      default: false
    },
    freezer:{
     type: Boolean,
      default: false
    },
    showBack: {
      type: Boolean,
      default: true
    },
    pathSetType: {
      type: String,
      default: ''
    },
    pathInfo: {
      type: Array,
      default: () => {
        return []
      }
    },
    perfectNavList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      breadcrumbList: [],
      pageTitle: '',
      canApply: false,
      canMoney: false,
      canApprove: false,
      canStock: false,
      canQuota: false,
      activeIndex:'scrap'
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  watch: {
    pathInfo () {
      this.initBreadcrumb()
    },
    '$route.meta' () {
      this.initBreadcrumb()
    }
  },
  created () {
    this.init()
    this.initBreadcrumb()
  },
  methods: {
    init () {
      if (this.userInfo.clientAuthorizationCodeList) {
        this.userInfo.clientAuthorizationCodeList.forEach(item => {
          switch (item) {
            case 'stock:apply:apply':
              this.canApply = true
              break
            case 'stock:quota:amount':
              this.canMoney = true
              break
            case 'stock:apply:approve':
              this.canApprove = true
              break
            case 'stock:out:manage':
              this.canStock = true
              break
            case 'stock:quota:quantity':
              this.canQuota = true
              break
          }
        })
      }
    },
    initBreadcrumb () {
      const metaDefined = this.$route.meta.breadcrumb || []
      this.pageTitle = this.$route.meta.title || ''
      this.breadcrumbList = []
      const containHome = metaDefined.some(item => {
        return item.path === '/'
      })
      if (!containHome) {
        // this.breadcrumbList.push({ path: '/', name: 'POCM首页' })
        this.breadcrumbList.push({ path: '/', name: '尊享先锋订单平台首页' })
      }
      if (this.pathSetType === 'replace') {
        this.breadcrumbList = this.breadcrumbList.concat(this.pathInfo)
      } else {
        if (metaDefined.length > 0) {
          this.breadcrumbList = this.breadcrumbList.concat(metaDefined)
        }
        if (this.pathSetType === 'append') {
          this.breadcrumbList = this.breadcrumbList.concat(this.pathInfo)
        }
      }
      const lastItem = this.breadcrumbList[this.breadcrumbList.length - 1]
      if (!lastItem.replaceTitle) {
        this.breadcrumbList.push({ name: this.pageTitle })
      }
    },
    pageBack () {
     if(this.$route.path==='/trade/cooler/all'||this.$route.path==='/trade/cooler/store'){
       this.$router.push('/trade/index')
       return
     }
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.com-page {
  height: 100px;
  box-sizing: border-box;
  color: $base-white;
  background: url("../assets/images/banner-sub.jpg") center no-repeat;
  background-size: cover;
  position: relative;
  .com-content {
    display: flex;
    box-sizing: border-box;
    width: 1200px;
    height: 100px;
    margin: auto;

    .page-block {
      flex: 1;
      padding: 12px 50px;
      .page-path {
        font-size: $font-12;
        line-height: 16px;

        a, a:link, a:visited, a:hover {
          color: $base-white;
        }

        .blank-path {
          color: $base-white;
        }
      }
      .page-name {
        margin: 12px 0;
        font-size: 24px;
        line-height: 40px;
      }
    }
    .button-block {
      text-align: right;
      padding: 30px 50px 0 0;
      flex: 1;

      .back {
        color: $base-yellow;
        border-width: 0px;
        font-weight: 700;

        & :hover  {
          background-color: $base-white;
          color: $base-red;
          border-color: $base-white;
        }
        &:active, &::after {
          background-color: $base-white;
          color: $base-red;
          border-color: $base-white;
        }
        &:focus {
          background-color: $base-white;
          color: $base-red;
          outline: none;
          border-color: $base-white;
        }
      }
    }
  }
  .com-nav {
    height: 50px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-43%);

    ::v-deep .el-menu {
      display: flex;
      justify-content: center;
    }

    ::v-deep .el-menu-item {
      color: $base-white;
    }
    ::v-deep .el-menu-item.is-disabled {
      // color: $base-dark;
      opacity: .7;
    }
  }
}
</style>
